import { API_BASE_URL } from '../config/serverApiConfig';
import { api } from './api';

export type NodeKind = 'organisation' | 'entity' | 'workspace';

export interface TreeNode {
  id: number;
  kind: NodeKind;
  name: string;
  slug: string;
  /** null when the parent is unreachable for this caller, so the node is top-level. */
  parent_id: number | null;
  display_path: string;
  current_user_role: string | null;
  has_console: boolean;
  children: TreeNode[];
}

/**
 * Every node the caller can reach, nested. Ancestors the caller cannot reach never appear,
 * so a node whose parent is hidden comes back as a root.
 *
 * Read uncached: the tree changes on rename and create, and a stale copy would show a
 * switcher that disagrees with the page the operator just edited. Errors throw; the
 * context thunk owns the handling.
 */
export const getTree = async (): Promise<TreeNode[]> => {
  const response = await api().get(`${API_BASE_URL}r/v2/tree`, { 
    cache: false 
  } as any);
  return response.data;
};
